import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { Table } from 'reactstrap';
import { getCommitment } from '../../../constants/apiCalls';
import editImg from '../../../images/edit2.png'
import FYearService from '../../../services/FYearService';
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../utils/utils';
import './index.css'

const CommonCommitment = ({ userId, commitData, upload, handleEditCommitment }) => {
    let fYYear = FYearService.getFYear();
    const location = useLocation();
    const [commitmentData, setCommitmentData] = useState('');

    useEffect(() => {
        getCommitments();
    }, [])

    useEffect(() => {
        let objData = { commitmentData, getCommitments };
        commitData(objData);
    }, [commitmentData])

    const getCommitments = () => {
        if (userId) {
            let payload = { user_id: userId, page: 1, pagesize: 50, year: '' };
            getCommitment((res) => {
                const { success, data, error } = res;
                if (success === true) {
                    if (location.pathname.includes('/pages/kyc')) {
                        let currentYearData = data && data.length > 0 ? data.filter(val => val.year === fYYear.currentFinancialYear) : [];
                        setCommitmentData(currentYearData);
                    } else {
                        setCommitmentData(data);
                    }
                } else if (success === false || success === 'undefined') {
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                }
            }, payload);
        }
    };

    const calculateYearlyPrice = (data) => {
        let sum = 0;
        sum = data.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
        if (sum > 0) {
            sum = Number(sum.toFixed(4));
        }
        return sum;
    };

    return (
        <>
            {commitmentData && commitmentData.length > 0 ? (
                <Table responsive className='text-center'>
                    <thead>
                        <tr>
                            <th>Product Name</th>
                            <th>{fYYear.next3FinancialYear[0]}</th>
                            <th>{fYYear.next3FinancialYear[1]}</th>
                            <th>{fYYear.next3FinancialYear[2]}</th>
                            <th>Total</th>
                            {location && (location.pathname.includes('/pages/business-commitment') || location.pathname.includes('/pages/kyc')) ? <th>Action</th> : ''}
                        </tr>
                    </thead>
                    <tbody>
                        {commitmentData.map((row, i) => {
                            return (
                                <tr key={i}>
                                    <td key={100}>{row.product_name}</td>
                                    <td>
                                        <div>
                                            {row.commitments &&
                                                row.commitments[0]
                                                    .first_year_commitment}{' '}
                                            {row.unit_type}
                                        </div>
                                        <div className='mt-2'>
                                            {row.commitment_prices &&
                                                row.commitment_prices[0]
                                                    .first_year_commitment_price
                                                ? `${row.commitment_prices[0]
                                                    .first_year_commitment_price} Lakh`
                                                : '0 Lakh'}
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            {row.commitments &&
                                                row.commitments[1]
                                                    .second_year_commitment}{' '}
                                            {row.unit_type}
                                        </div>
                                        <div className='mt-2'>
                                            {row.commitment_prices &&
                                                row.commitment_prices[1]
                                                    .second_year_commitment_price
                                                ? `${row.commitment_prices[1]
                                                    .second_year_commitment_price} Lakh`
                                                : '0 Lakh'}
                                        </div>
                                    </td>
                                    <td>
                                        <div>
                                            {row.commitments &&
                                                row.commitments[2]
                                                    .third_year_commitment}{' '}
                                            {row.unit_type}
                                        </div>
                                        <div className='mt-2'>
                                            {row.commitment_prices &&
                                                row.commitment_prices[2]
                                                    .third_year_commitment_price
                                                ? `${row.commitment_prices[2]
                                                    .third_year_commitment_price} Lakh`
                                                : '0 Lakh'}
                                        </div>
                                    </td>
                                    <td key={104} style={{ fontWeight: '700' }}>
                                        <div>
                                            {row.total} {row.unit_type}
                                        </div>
                                        <div
                                            className='mt-2'
                                            style={{ color: '#545CD8' }}
                                        >
                                            {row.total_price
                                                ? `${row.total_price} Lakh`
                                                : '0 Lakh'}
                                        </div>
                                    </td>
                                    {location && (location.pathname.includes('/pages/business-commitment') || location.pathname.includes('/pages/kyc') ? <td key={109}>
                                        {/* Page Business Commitment */}
                                        {location && location.pathname.includes('/pages/business-commitment') ? (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                {!upload ? (
                                                    <img
                                                        className='iconImg cursorPointer noprint'
                                                        onClick={() => handleEditCommitment(row, 2)}
                                                        src={editImg}
                                                        alt="editImg"
                                                    />
                                                ) : ''}
                                            </div>
                                        ) : ''}

                                        {/* Page KYC */}
                                        {location && location.pathname.includes('/pages/kyc') ? (
                                            <div className='d-flex align-items-center justify-content-center'>
                                                <img
                                                    className='iconImg cursorPointer noprint'
                                                    onClick={() => handleEditCommitment(row, 2)}
                                                    src={editImg}
                                                    alt="editImg"
                                                />
                                            </div>
                                        ) : ''}
                                    </td> : '')}
                                </tr>
                            );
                        })}
                        <tr>
                            <td><b>Total</b></td>
                            <td><b>{calculateYearlyPrice(commitmentData.map(item => item.commitment_prices[0].first_year_commitment_price))} Lakh</b></td>
                            <td><b>{calculateYearlyPrice(commitmentData.map(item => item.commitment_prices[1].second_year_commitment_price))} Lakh</b></td>
                            <td><b>{calculateYearlyPrice(commitmentData.map(item => item.commitment_prices[2].third_year_commitment_price))} Lakh</b></td>
                            <td><b>{calculateYearlyPrice(commitmentData.map(item => item.total_price))} Lakh</b></td>
                            <td>&nbsp;</td>
                        </tr>
                    </tbody>
                </Table>
            ) : (
                location && location.pathname.includes('/pages/kyc') ? (
                    <div className='text-center'>We do not find any record matching this year !</div>
                ) : ''
            )}
        </>
    )
}

export default CommonCommitment;